import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../../Styles/DaEmployee.css";
import Header from "../../Core/Header";
import { Section } from "../../Core/Section";
import { employeeList } from "../../Services/Operations/ProductAPI";
import { useSelector } from "react-redux";
import {
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfYear,
  endOfYear,
} from "date-fns";
import { baseURL } from "../../Services/api_endpoints";
import axios from "axios";

const formatDate = (date) => date.toLocaleDateString().split("T")[0];

const getDateRange = (filter, selectedDate, range) => {
  switch (filter) {
    case "day":
      return { from: selectedDate, to: selectedDate };
    case "week":
      return { from: startOfWeek(selectedDate), to: endOfWeek(selectedDate) };
    case "month":
      return { from: startOfMonth(selectedDate), to: endOfMonth(selectedDate) };
    case "year":
      return { from: startOfYear(selectedDate), to: endOfYear(selectedDate) };
    case "range":
      return { from: range[0], to: range[1] };
    default:
      return { from: selectedDate, to: selectedDate };
  }
};

export default function DaEmployee() {
  const token = useSelector((state) => state.user.token);
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [range, setRange] = useState([new Date(), new Date()]);
  const [filter, setFilter] = useState("day");
  const [daData, setDaData] = useState([]);

  useEffect(() => {
    const fetchEmployeeList = async () => {
      try {
        const response = await employeeList(token);
        setEmployees(response);
      } catch (error) {
        console.error("Error fetching employee list:", error);
      }
    };

    fetchEmployeeList();
  }, [token]);

  // Update range automatically for week/month/year when selectedDate or filter changes
  useEffect(() => {
    if (filter === "week") {
      setRange([startOfWeek(selectedDate), endOfWeek(selectedDate)]);
    } else if (filter === "month") {
      setRange([startOfMonth(selectedDate), endOfMonth(selectedDate)]);
    } else if (filter === "year") {
      setRange([startOfYear(selectedDate), endOfYear(selectedDate)]);
    }
  }, [filter, selectedDate]);

  const fetchDaData = async () => {
    if (!selectedEmployee) return;

    const { from, to } = getDateRange(filter, selectedDate, range);
  console.log("employee ",selectedEmployee,
            "fromDate:", formatDate(from),
           " toDate:", formatDate(to));
  
    try {
      const response = await axios.get(
        baseURL+"adminweb/da/get",{
           
            employee: selectedEmployee,
            fromDate: formatDate(from),
            toDate: formatDate(to),
          
        },
        {
    
          headers: {
           
            Authorization: `Bearer ${token}`,
          },
        
        }
      );
      const result = await response.json();
      setDaData(result.data || []);
    } catch (err) {
      console.error("Failed to fetch DA data:", err);
      setDaData([]);
    }
  };

  const total = daData.reduce((sum, e) => sum + e.amount, 0);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="ex-page-container">
          <h1 className="ex-title">Employee Expenditure Report</h1>

          <div className="ex-controls">
            <select
              className="ex-dropdown"
              value={selectedEmployee}
              onChange={(e) => setSelectedEmployee(e.target.value)}
            >
              <option value="">Select Employee</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.firstName}>
                  {emp.firstName}
                </option>
              ))}
            </select>

            <div className="ex-filters">
              {["day", "week", "month", "year", "range"].map((opt) => (
                <button
                  key={opt}
                  className={`ex-filter-btn ${filter === opt ? "active" : ""}`}
                  onClick={() => setFilter(opt)}
                  style={{color:"black"}}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>

          <div className="ex-calendar-wrapper">
            <Calendar
              onChange={(val) => {
                if (filter === "range") setRange(val);
                else setSelectedDate(val);
              }}
              className="custom-calendar"
              value={filter === "range" ? range : selectedDate}
              selectRange={filter === "range"}
            />
          </div>

          <div className="ex-submit-section">
            <button className="ex-submit-btn" onClick={fetchDaData}>
              Submit
            </button>
          </div>

          <div className="ex-data-section">
            <h2 className="ex-subheading">
              {selectedEmployee
                ? `${selectedEmployee}'s`
                : "Select an employee"}{" "}
              expenditures from{" "}
              <strong>
                {formatDate(getDateRange(filter, selectedDate, range).from)} to{" "}
                {formatDate(getDateRange(filter, selectedDate, range).to)}
              </strong>
              :
            </h2>

            {daData.length === 0 ? (
              <p className="ex-no-data">No expenditures recorded.</p>
            ) : (
              <div className="ex-list">
                {daData.map((item, idx) => (
                  <div key={idx} className="ex-card">
                    <div>
                      <p className="ex-topic">{item.topic}</p>
                    </div>
                    <div className="ex-amount">₹{item.amount}</div>
                  </div>
                ))}
                <div className="ex-total">Total: ₹{total}</div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
